import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=71c447a8"
import script from "./ExpandableText.vue?vue&type=script&lang=ts"
export * from "./ExpandableText.vue?vue&type=script&lang=ts"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&id=71c447a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports